<template>
    <div :class="{ 'dark': store.state.global.isDark }">
        <Head title="Register" />
        <div :class="{ 'dark:bg-gray-900 h-screen': currentRoute === 'register' }" class="flex items-center justify-center" v-if="shouldDisableRegistrations">
            <p class="text-center" :class="{ 'dark:text-racing-stars-yellow': currentRoute === 'register' }">Public registrations will be open soon. Please check back shortly to join our public beta program.</p>
        </div>
        <div v-else>
            <default-authentication-card >
                <template #logo>
                    <Link class="block w-full" method="get" :href="route('dashboard')">
                    <span v-if="$page.props.racingstars.site =='Racing League'">
                        <img :src="'/images/racingleague/racingleague-live.png'" alt="">
                    </span>
                    <span v-else-if="$page.props.settings.site_name ==='Zilliqa'">
                        <img :src="'/images/logos/twc-the-game.png'" alt="">
                    </span>
                    <span v-else>
                       <jet-authentication-card-logo />
                </span>
                    </Link>
                </template>
                <jet-form-stepper :steps="steps" @setStep="setSelectedStep($event)" />
                <jet-validation-errors class="mb-4" />
                <form @submit.prevent="submit">
                    
                    <div v-show="selectedStep.id === 'personal-details'">
                        <div class="mt-4">
                            <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="email" value="Email*" />
                            <jet-input :required="selectedStep.id === 'personal-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="email" type="email" class="mt-1 block w-full" v-model="form.email" autofocus autocomplete="email" />
                        </div>
                        <div class="flex mt-4 gap-2">
                            <div class="w-1/2 ">
                                <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="first_name" value="First Name*" />
                                <jet-input :required="selectedStep.id === 'personal-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="first_name" type="text" class="mt-1 block w-full" v-model="form.first_name"  autocomplete="given-name" />
                            </div>
                            <div class="w-1/2">
                                <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="last_name" value="Last Name*" />
                                <jet-input :required="selectedStep.id === 'personal-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="last_name" type="text" class="mt-1 block w-full" v-model="form.last_name" autocomplete="family-name" />
                            </div>
                        </div>

                        <div class="mt-4">
                            <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="date_of_birth" value="Date of Birth*" />

                            <div class="flex justify-center rounded border border-grey items-center mt-2">
                                <jet-input :ignore-dark-mode="true" v-model="form.day" class="p-2   dark:bg-transparent relative block w-full rounded-none" placeholder="dd" maxlength="2" @keyup="updateDateOfBirth" /><span class="text-grey">/</span>
                                <jet-input :ignore-dark-mode="true" v-model="form.month" class="p-2     dark:bg-transparent relative block w-full rounded-none" placeholder="mm" maxlength="2" @keyup="updateDateOfBirth" /><span class="text-grey">/</span>
                                <jet-input :ignore-dark-mode="true" maxlength="4" v-model="form.year" class="p-2    dark:bg-transparent relative block w-full rounded-none" placeholder="yyyy" @keyup="updateDateOfBirth" />
                            </div>
                        </div>
                        <div class="flex items-center justify-end mt-4">
                            <jet-button type="button" @click="nextStep(selectedStep)" :class="{ 'opacity-25': stepIsDisabled(selectedStep) }" :disabled="stepIsDisabled(selectedStep)">
                                Next
                            </jet-button>
                        </div>
                    </div>
                    <div v-show="selectedStep.id === 'user-details'">
                        <div class="mt-4">
                            <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="username" value="Username (Displayed Publicly)" />
                            <jet-input :required="selectedStep.id === 'user-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="username" type="text" class="mt-1 block w-full" v-model="form.username" autocomplete="username" />
                        </div>
                        <div v-if="$page.props.settings.site_name == 'Racing League'">
                            <button required name="team" id="dropdownteamsButton" @click="toggleDropdown" class="text-white font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center w-full mt-6 backdrop-blur" :class="[selectedTeam ? selectedTeam.background : 'btn', isDropdownOpen ? 'rounded-b-none' : '']" type="button">
                                <span class="inline-flex w-full justify-between">
                                    <p v-if="!selectedTeam"> Choose your team </p>
                                
                                    <a v-else class="flex items-center text-base p-0 hover:text-white">
                                        <img class="w-6 h-6 mr-2" :src="selectedTeam.icon" :alt="selectedTeam.name + ' image'">
                                        {{ selectedTeam.name }}
                                    </a>

                                    <svg class="w-5 h-5 ml-2 my-auto" aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                    </svg>
                                </span>
                            </button>

                            <div :class="{'hidden': !isDropdownOpen}" id="dropdownteams" class="rounded-lg rounded-t-none shadow w-full bg-gray-900">
                                <ul @click="toggleDropdown" class="h-48 overflow-y-auto text-gray-700 dark:text-gray-200 rounded-md" aria-labelledby="dropdownteamsButton">
                                    <li @click="selectedTeam=team" v-for="team in teams" :key="team.id">
                                    <a href="#" class="flex items-center text-base px-4 py-2 hover:opacity-90 hover:text-white" :class="[team.background]">
                                        <img class="w-6 h-6 mr-2" :src="team.icon" :alt="team.name + ' image'">
                                        {{ team.name }}
                                    </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="mt-4">
                            <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="password" value="Password" />
                            <jet-input :required="selectedStep.id === 'user-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="password" type="password" class="mt-1 block w-full" v-model="form.password" autocomplete="new-password" />
                        </div>
                        <div class="mt-4">
                            <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="password_confirmation" value="Confirm Password" />
                            <jet-input :required="selectedStep.id === 'user-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" autocomplete="new-password" />
                        </div>
                    </div>
                    <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature && selectedStep.id === 'user-details'">
                        <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="terms">
                            <div class="flex items-center">
                                <jet-checkbox :required="selectedStep.id === 'user-details'" :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="terms" v-model:checked="form.terms" />
                                <div class="ml-2">
                                    I agree to the <a target="_blank" :href="route('terms.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a> and that I am a resident of the United Kingdom.
                                </div>
                            </div>
                        </jet-label>
                        <jet-label :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" for="gdpr_email" class="mt-3">
                            <div class="flex items-center">
                                <jet-checkbox :ignore-dark-mode="currentRoute === 'register' ? true : ignoreDarkMode" id="gdpr_email" v-model:checked="form.gdpr_email" />
                                <div class="ml-2">
                                    I agree to receive the occasional marketing updates about promotions from Racing Stars & our partners <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Learn More</a>
                                </div>
                            </div>
                        </jet-label>
                    </div>
                    <div class="flex items-center justify-end mt-4">
                        <jet-button type="button" v-if="selectedStep.id === 'user-details'" class="mr-4" @click="prevStep(selectedStep)">
                            Prev
                        </jet-button>

                        <jet-button type="submit" v-if="selectedStep.id === 'user-details'" class="ml-4" :class="[form.processing || stepIsDisabled(selectedStep) ? 'opacity-25' : '']" :disabled="form.processing || stepIsDisabled(selectedStep) || (!selectedTeam && $page.props.settings.site_name == 'Racing League')">
                            Register
                        </jet-button>
                    </div>
                </form>
            </default-authentication-card>
        </div>
    </div>

</template>
<script>
import DefaultAuthenticationCard from '@/Jetstream/DefaultAuthenticationCard.vue'
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetFormStepper from '@/Jetstream/FormStepper.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetDatePicker from '@/Jetstream/DatePicker.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import MultiSelect from '@vueform/multiselect'
import { Head, Link } from '@inertiajs/inertia-vue3'
import { useStore } from 'vuex'
import { ref, computed } from 'vue'


export default {
    props: {
        email: String,
        ignoreDarkMode: Boolean,
        user: Object,
    },

    components: {
        Head,
        DefaultAuthenticationCard,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetFormStepper,
        JetButton,
        JetInput,
        JetDatePicker,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        MultiSelect,
        Link,
    },

    data() {
        return {

            teams: [
                { id: 1, name: 'Wales & The West', icon: 'images/racingleague/rl-wales.svg', value:"wales", background:"bg-rl-wales/70" ,foreground:"text-rl-wales/80" },
                { id: 2, name: 'London & The South', icon: 'images/racingleague/rl-london.svg', value:"london", background:"bg-rl-london/70" ,foreground:"text-rl-london/80"},
                { id: 3, name: 'Scotland', icon: 'images/racingleague/rl-scotland.svg', value:"scotland", background:"bg-rl-scotland/70" ,foreground:"text-rl-scotland/80"},
                { id: 4, name: 'The East', icon: 'images/racingleague/rl-east.svg', value:"east", background:"bg-rl-east/70" ,foreground:"text-rl-east/80"},
                { id: 5, name: 'Yorkshire', icon: 'images/racingleague/rl-yorkshire.svg', value:"yorkshire", background:"bg-rl-yorkshire/70" ,foreground:"text-rl-yorkshire/80"},
                { id: 6, name: 'The North', icon: 'images/racingleague/rl-north.svg', value:"north", background:"bg-[#1b2335] bg-opacity-70" ,foreground:"text-[#2b3b61]"},
                { id: 7, name: 'Ireland', icon: 'images/racingleague/rl-ireland.svg', value:"ireland", background:"bg-rl-ireland/70" ,foreground:"text-rl-ireland/80"},
            ],

            steps: [
                { id: 'personal-details', name: 'Personal Details', href: '#', status: 'current' },
                { id: 'user-details', name: 'User Details', href: '#', status: 'upcoming' },
            ],

            selectedStep: { id: 'personal-details', name: 'Personal Details', href: '#', status: 'current' },

            currentRoute: route().current(),

            address: null,

            code: route().params.code,

            referral_code: route().params.referral_code,

            isDropdownOpen: false,

            store: useStore(),

            shouldDisableRegistrations: false,

            form: this.$inertia.form({
                first_name: route().params.first_name ?? '',
                last_name: route().params.last_name ?? '',
                day: '',
                month: '',
                year: '',
                date_of_birth: '',
                email: route().params.email ?? '',
                mobile: '',
                building: '',
                street: '',
                city: '',
                postcode: '',
                country_id: 169,
                username: '',
                password: '',
                gdpr_email: false,
                password_confirmation: '',
                terms: false,
                avatar: route().params.avatar ?? '',
            }),

            format: {
                date: 'DD/MM/YYYY',
                month: 'MMM'
            },

            addresses: async (query) => {
                return await this.addressSearch(query)
            },

            tailwindClasses: {
                container: 'relative mx-auto w-full flex items-center justify-end box-border cursor-pointer border border-gray-300 rounded bg-white text-base leading-snug outline-none',
                containerDisabled: 'cursor-default bg-gray-100',
                containerOpen: 'rounded-b-none',
                containerOpenTop: 'rounded-t-none',
                containerActive: 'ring ring-green-500 ring-opacity-30',
                singleLabel: 'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5',
                multipleLabel: 'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5',
                search: 'w-full absolute inset-0 outline-none appearance-none box-border border-0 text-base font-sans bg-white rounded pl-3.5',
                tags: 'flex-grow flex-shrink flex flex-wrap items-center mt-1 pl-2',
                tag: 'bg-green-500 text-white text-sm font-semibold py-0.5 pl-2 rounded mr-1 mb-1 flex items-center whitespace-nowrap',
                tagDisabled: 'pr-2 opacity-50',
                tagRemove: 'flex items-center justify-center p-1 mx-0.5 rounded-sm hover:bg-black hover:bg-opacity-10 group',
                tagRemoveIcon: 'bg-multiselect-remove bg-center bg-no-repeat opacity-30 inline-block w-3 h-3 group-hover:opacity-60',
                tagsSearchWrapper: 'inline-block relative mx-1 mb-1 flex-grow flex-shrink h-full',
                tagsSearch: 'absolute inset-0 border-0 outline-none appearance-none p-0 text-base font-sans box-border w-full',
                tagsSearchCopy: 'invisible whitespace-pre-wrap inline-block h-px',
                placeholder: 'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 text-gray-400',
                caret: 'bg-multiselect-caret bg-center bg-no-repeat w-2.5 h-4 py-px box-content mr-3.5 relative z-10 opacity-40 flex-shrink-0 flex-grow-0 transition-transform transform pointer-events-none',
                caretOpen: 'rotate-180 pointer-events-auto',
                clear: 'pr-3.5 relative z-10 opacity-40 transition duration-300 flex-shrink-0 flex-grow-0 flex hover:opacity-80',
                clearIcon: 'bg-multiselect-remove bg-center bg-no-repeat w-2.5 h-4 py-px box-content inline-block',
                spinner: 'bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 mr-3.5 animate-spin flex-shrink-0 flex-grow-0',
                dropdown: 'max-h-60 absolute -left-px -right-px bottom-0 transform translate-y-full border border-gray-300 -mt-px overflow-y-scroll z-50 bg-white flex flex-col rounded-b',
                dropdownTop: '-translate-y-full top-px bottom-auto flex-col-reverse rounded-b-none rounded-t',
                dropdownHidden: 'hidden',
                options: 'flex flex-col p-0 m-0 list-none',
                optionsTop: 'flex-col-reverse',
                group: 'p-0 m-0',
                groupLabel: 'flex text-sm box-border items-center justify-start text-left py-1 px-3 font-semibold bg-gray-200 cursor-default leading-normal',
                groupLabelPointable: 'cursor-pointer',
                groupLabelPointed: 'bg-gray-300 text-gray-700',
                groupLabelSelected: 'bg-green-600 text-white',
                groupLabelDisabled: 'bg-gray-100 text-gray-300 cursor-not-allowed',
                groupLabelSelectedPointed: 'bg-green-600 text-white opacity-90',
                groupLabelSelectedDisabled: 'text-green-100 bg-green-600 bg-opacity-50 cursor-not-allowed',
                groupOptions: 'p-0 m-0',
                option: 'flex items-center justify-start box-border text-left cursor-pointer text-base leading-snug py-2 px-3',
                optionPointed: 'text-gray-800 bg-gray-100',
                optionSelected: 'text-white bg-green-500',
                optionDisabled: 'text-gray-300 cursor-not-allowed',
                optionSelectedPointed: 'text-white bg-green-500 opacity-90',
                optionSelectedDisabled: 'text-green-100 bg-green-500 bg-opacity-50 cursor-not-allowed',
                noOptions: 'py-2 px-3 text-gray-600 bg-white',
                noResults: 'py-2 px-3 text-gray-600 bg-white',
                fakeInput: 'bg-transparent absolute left-0 right-0 -bottom-px w-full h-px border-0 p-0 appearance-none outline-none text-transparent',
                spacer: 'h-9 py-px box-content',
            },
        }
    },

    mounted() {
        this.form.country_id = '169'
    },

    methods: {
        updateDateOfBirth(event) {
            this.form.date_of_birth = this.form.day+'/'+this.form.month+'/'+this.form.year
        },

        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },

        submit() {
            this.form.transform((data) => ({
                    ...data,
                    referrer: this.referral_code,
                    team: this.selectedTeam.value,

                }))
                .post(this.route('register'), {
                    onFinish: () => {
                        this.form.reset('password', 'password_confirmation')
                    },

                    onSuccess: () => {
                        if (this.code) {
                            this.$inertia.get(route('leagues.show', this.code))
                        }

                        this.$gtm.trackEvent({
                            event: 'New User Registered',
                            category: 'Registrations',
                            action: 'Registration',
                            label: 'User '+this.form.first_name+' '+this.form.last_name+' Registered.',
                            value: 360,
                        })
                    }
                })
        },

        setStepStatuses() {
            let selectedStepIndex = this.steps.findIndex((step) => step.id === this.selectedStep.id)

            this.steps.forEach((step, i) => {
                if (i < selectedStepIndex) {
                    this.steps[i].status = 'complete'
                }

                if (i > selectedStepIndex) {
                    this.steps[i].status = 'upcoming'
                }

                if (i === selectedStepIndex) {
                    this.steps[i].status = 'current'
                }
            })
        },

        setSelectedStep(step) {
            let id = step.id

            let currentStepIndex = this.steps.findIndex((step) => step.id === this.selectedStep.id)
            let currentStep = this.steps[currentStepIndex]

            let selectedStepIndex = this.steps.findIndex((step) => step.id === id)
            let selectedStep = this.steps[selectedStepIndex]

            let prevStepIndex = this.steps.findIndex((step) => step.id === id) - 1
            let prevStep = this.steps[prevStepIndex]

            if (this.stepIsDisabled(prevStep)) {
                this.selectedStep = prevStep
            } else if (selectedStepIndex < currentStepIndex || !this.stepIsDisabled(currentStep)) {
                this.selectedStep = step
            }

            this.setStepStatuses()
        },

        addressSearch(query) {
            return axios.post('/api/locate', { query: query })
                .then(response => {
                    return response.data
                });
        },

        selectAddress() {
            axios.post('/api/locate/address', { id: this.address })
                .then(response => {
                    this.address = null
                    this.form.building = response.data.building
                    this.form.street = response.data.flat_number ? response.data.flat_number + ', ' + response.data.street : response.data.street
                    this.form.city = response.data.city
                    this.form.postcode = response.data.postcode
                });
        },

        nextStep(currentStep) {
            let nextStepIndex = this.steps.findIndex((step) => step.id === currentStep.id) + 1
            let nextStep = this.steps[nextStepIndex]

            this.selectedStep = nextStep

            this.setStepStatuses()
        },

        prevStep(currentStep) {
            let prevStepIndex = this.steps.findIndex((step) => step.id === currentStep.id) - 1
            let prevStep = this.steps[prevStepIndex]

            this.selectedStep = prevStep

            this.setStepStatuses()
        },

        isEmpty(str) {
            return (!str || str.length === 0)
        },

        isDirty(str) {
            var regName = /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i;
            if(!regName.test(str)){
                return true;
            }
            return false;
        },

        isNotValid(str) {
            if (this.form.day.length !== 2 || this.form.month.length !== 2 || this.form.year.length !== 4) {
                return true
            }

            if (!str || str.length === 0) {
                return true
            }

            return false
        },

        stepIsDisabled(step) {
            if (step !== undefined) {
                if (step.id === 'personal-details') {
                    return this.isEmpty(this.form.first_name) ||
                        this.isDirty(this.form.first_name) ||
                        this.isDirty(this.form.last_name) ||
                        this.isEmpty(this.form.last_name) ||
                        this.isNotValid(this.form.date_of_birth) ?
                        true :
                        false
                }

                if (step.id === 'contact-details') {
                    return this.isEmpty(this.form.mobile) ||
                        this.isEmpty(this.form.email) ?
                        true :
                        false
                }

                if (step.id === 'address-details') {
                    return this.isEmpty(this.form.building) ||
                        this.isEmpty(this.form.street) ||
                        this.isEmpty(this.form.city) ||
                        this.isEmpty(this.form.postcode) ?
                        true :
                        false
                }

                if (step.id === 'user-details') {
                    return this.isEmpty(this.form.password) ||
                        this.isEmpty(this.form.password_confirmation) ||
                        this.isEmpty(this.form.username) ||
                        !this.form.terms ?
                        true :
                        false
                }
            }

            return false
        }
    },

    setup(props) {

        const selectedTeam = ref(0)

        return {
            selectedTeam
        }

    },
}

</script>
